
import { useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "@/lib/auth/auth-context";
import { SignInPage } from "@/components/ui/sign-in";

export default function SignupPage() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { signUp } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !password) return;
    setError("");
    setLoading(true);
    try {
      const { hasTeams } = await signUp(email, password, firstName || undefined, lastName || undefined);
      if (!hasTeams) {
        navigate("/onboarding");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not create account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignInPage
      title={
        <span className="font-bold tracking-tight" style={{ fontFamily: "var(--font-syne)" }}>
          eT<span className="text-primary-500">X</span>
          <span className="text-zinc-300 mx-0.5 text-3xl font-light">·</span>
          Impa<span className="text-primary-500">X</span>t
        </span>
      }
      description="Create your account and start estimating in minutes."
      heroVariant="signup"
      email={email}
      password={password}
      onEmailChange={setEmail}
      onPasswordChange={setPassword}
      onSignIn={handleSubmit}
      isLoading={isLoading}
      error={error}
      submitLabel="Create Account"
      headerContent={
        <>
          <div className="animate-element animate-delay-100">
            <label className="text-sm font-medium text-zinc-500 block mb-1.5">First Name</label>
            <div className="rounded-2xl border border-zinc-200 bg-zinc-50 transition-colors focus-within:border-zinc-400 focus-within:bg-white">
              <input
                name="firstName"
                type="text"
                placeholder="Enter your first name"
                autoComplete="given-name"
                disabled={isLoading}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-full bg-transparent text-sm text-zinc-900 placeholder:text-zinc-400 p-4 rounded-2xl focus:outline-none disabled:opacity-50"
              />
            </div>
          </div>
          <div className="animate-element animate-delay-200">
            <label className="text-sm font-medium text-zinc-500 block mb-1.5">Last Name</label>
            <div className="rounded-2xl border border-zinc-200 bg-zinc-50 transition-colors focus-within:border-zinc-400 focus-within:bg-white">
              <input
                name="lastName"
                type="text"
                placeholder="Enter your last name"
                autoComplete="family-name"
                disabled={isLoading}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="w-full bg-transparent text-sm text-zinc-900 placeholder:text-zinc-400 p-4 rounded-2xl focus:outline-none disabled:opacity-50"
              />
            </div>
          </div>
        </>
      }
    >
      <p className="text-center text-sm text-zinc-500 mt-2">
        Already have an account?{" "}
        <button onClick={() => navigate("/login")} className="text-zinc-900 font-medium hover:underline transition-colors">
          Sign In
        </button>
      </p>

      <p className="text-[11px] text-zinc-300 pt-2">
        © {new Date().getFullYear()} Badders Holding Company LLC
      </p>
    </SignInPage>
  );
}
